import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import * as pagesConfig from '../config/pages-config';
import { DisableDeepLinksGuard } from './common/authentication/disable-deeplinks.guard';
import { GeneralErrorComponent } from './common/shared-components/general-error/general-error.component';
import { UnauthorizedComponent } from './common/shared-components/unauthorized/unauthorized.component';

const routes: Routes = [

  {
    path: '',
    redirectTo: pagesConfig.config.topupPayment.review.route,
    pathMatch: 'full',
  },
  {
    // Unauthorized
    path: pagesConfig.config.unauthorized.name,
    component: UnauthorizedComponent,
    pathMatch: 'full',
  },
  {
    // general error handleing page
    path: pagesConfig.config.generalError.name,
    component: GeneralErrorComponent,
    pathMatch: 'full',
    canActivate: [DisableDeepLinksGuard],
  },
  {
    // topup payment
    path: pagesConfig.config.topupPayment.name,
    loadChildren: () => import('./topup-payment/topup-payment.module').then(m => m.TopupPaymentModule),
  },
  {
    // dunning payment
    path: pagesConfig.config.dunning.name,
    loadChildren: () => import('./dunning-payment/dunning-payment.module').then(m => m.DunningPaymentModule),
  },

];

/** AppRoutingModule */
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false})],
  exports: [RouterModule],
})

export class AppRoutingModule { }
